import { Injectable, Injector } from "@angular/core";
import { LocalStoreService } from "./local-store.service";
import { Router } from "@angular/router";
import { of, Observable } from "rxjs";
import { delay, map, catchError } from "rxjs/operators";
import { ToastrService } from 'ngx-toastr';
import { JwtHelperService } from '@auth0/angular-jwt';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: "root"
})
export class AuthorizationService {
    //Only for demo purpose
    authenticated = false;
    private jwtHelper: JwtHelperService;
    constructor(private store: LocalStoreService,
        private router: Router,
        private http: HttpClient,
        private toastr: ToastrService,
        private injector: Injector) {
    }

    testAuth() {
        //console.log(this.jwtHelper.tokenGetter());
        //console.log('entered > ' + new Date());
        if (this.getAccessToken() === null) {
            this.router.navigateByUrl('/sessions/signin');
            return of(false);
            //return;
        }
        this.jwtHelper = this.injector.get(JwtHelperService);
        //let tokenExpired = this.jwtHelper.isTokenExpired(this.getAccessToken());
        let refreshToken = this.store.getRawItem('refresh_token');

        if(!refreshToken)
        {
            this.router.navigateByUrl('/sessions/signin');
            return of(false);
        }
        
        return this.http.post(`${environment.apiUrl}/auth/refreshtoken`, { token: refreshToken, accessToken: this.getAccessToken() }, {
            headers: new HttpHeaders({
                "Content-Type": "application/json"
            })
        }).pipe(
            map(response => {
                let token = (<any>response).actionToken;
                let refreshToken = (<any>response).refreshToken;
                this.store.setRawItem('access_token', token);
                this.store.setRawItem('refresh_token', refreshToken);
                return true;
            }), catchError((err) => {
                this.toastr.error(err.error.title, 'Error!', { progressBar: true });
                this.store.removeItem('access_token');
                this.store.removeItem('refresh_token');
                this.store.removeItem('user_info');
                //return false;
                this.router.navigateByUrl('/sessions/signin');
                return of(false);
            }));


    }

    getAccessToken() {
        return this.store.getRawItem('access_token');
    }
}